import { render, staticRenderFns } from "./StartupListPage.vue?vue&type=template&id=1c4ed7a4&"
import script from "./StartupListPage.vue?vue&type=script&lang=js&"
export * from "./StartupListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports